<template>
    <date-picker
        is-range
        show-caps
        mode="date"
        :columns="2"
        :min-date="minDate"
        :max-date="maxDate"
        nav-visibility="click"
        timezone="UTC"
        :first-day-of-week="1"
        :popover="{ visibility: 'click' }"
        :value="{
            start: onePageHorizon.date_start.$model,
            end: onePageHorizon.date_end.$model,
        }"
        @input="onChange"
    >
        <template v-slot="{ inputValue, inputEvents }">
            <div class="d-flex align-items-center">
                <i class="far fa-calendar-alt mr-2" />
                <input
                    :value="inputValue.start"
                    v-on="inputEvents.start"
                    v-mask="'##/##/####'"
                    :placeholder="$t('strategy.onepage.horizons.date.initial')"
                    :class="startDateInputClasses"
                />
                <input
                    :value="inputValue.end"
                    v-on="inputEvents.end"
                    v-mask="'##/##/####'"
                    :placeholder="$t('strategy.onepage.horizons.date.final')"
                    :class="endDateInputClasses"
                />
            </div>
        </template>
    </date-picker>
</template>
<script>
import i18n from '@/i18n'
import { mask } from 'vue-the-mask'
import moment from 'moment'
import { DatePicker, setupCalendar } from 'v-calendar'

setupCalendar({
    locale: i18n.locale,
})

const formatDate = (value) => moment(value, 'YYYY-MM-DD').toDate()

export default {
    directives: {
        mask,
    },
    components: {
        DatePicker,
    },
    props: {
        onePage: {
            type: Object,
            required: true,
        },
        onePageHorizon: {
            type: Object,
            required: true,
        },
        dateStartState: {
            type: Boolean | null,
            required: true,
        },
        dateEndState: {
            type: Boolean | null,
            required: true,
        },
    },
    computed: {
        minDate() {
            return formatDate(this.onePage.period_start)
        },
        maxDate() {
            return formatDate(this.onePage.period_end)
        },
        startDateInputClasses() {
            return this.createInputClassesObject('start')
        },
        endDateInputClasses() {
            return this.createInputClassesObject('end')
        },
    },
    methods: {
        createInputClassesObject(type) {
            const state = type == 'start' ? this.dateStartState : this.dateEndState

            return {
                'mr-2': type == 'start',
                'form-control': true,
                'is-invalid': state === false,
                'is-valid': state === true,
            }
        },
        onChange(dates) {
            this.$emit('change', dates)
        },
    },
}
</script>
